import React from 'react';
import tree from '../assets/trees.png';

export default function Trees(props) {
    return (
        <div style={styles.container}>
            <img src={tree} alt={"trees"} style={{ width: '100%', height: 'auto' }} />
        </div>
    );
};
const styles = {
    container:{
        width: '20%',
        height: '100%',
        display: 'flex',
        alignSelf: 'end',
    }
}